import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/Layout';
import ErrorBoundary from './components/ErrorBoundary';
import CheckoutPage from './pages/CheckoutPage';
import SuccessPage from './pages/SuccessPage';
import CancelledPage from './pages/CancelledPage';
import NotFoundPage from './pages/NotFoundPage';

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        {/* Inside the router so the fallback can still render links, but outside Routes
            so a throw in any page is caught rather than white-screening the app. */}
        <ErrorBoundary>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<CheckoutPage />} />
              <Route path="success" element={<SuccessPage />} />
              <Route path="cancelled" element={<CancelledPage />} />
              {/* Catch-all: an unknown path previously rendered a blank <main>. */}
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </ErrorBoundary>
      </BrowserRouter>
    </HelmetProvider>
  );
}